import { action, reaction, computed, observable } from 'mobx';
import { app } from '../App';
import { user, cart } from './AllStores';
import { IInsurance } from '../../../common/interfaces/insurance';

export class Insurance {
    private reactToUserLogin = reaction(
        () => user.isLoggedIn,
        loggedIn => {
            if (loggedIn) {
                this.fetchInsuranceJobs();
            }
        }
    );

    @observable public showInsuranceJobsList: boolean = false;
    @observable public insuranceJobs: IInsurance[] = [];
    @observable public search: string = '';

    @computed public get searchedInsuranceJobs(): IInsurance[] {
        if (this.search.trim() !== '') {
            const search = this.search.trim().toLowerCase();
            return this.insuranceJobs.filter(insurer => {
                const name = insurer.insuranceCode.toLowerCase();
                return name.indexOf(search) !== -1 ? true : false;
            });
        }

        return this.insuranceJobs;
    }

    @action
    private fetchInsuranceJobs = async (): Promise<boolean> => {
        try {
            const service = await app.service('insurance');
            const insurance = (await service.find()) as IInsurance[];

            this.insuranceJobs = insurance;

            return true;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Insurance.ts